import React from 'react';
import { Youtube, Tv, Award, Leaf } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { vedankurDifference } from '../mock';

const iconMap = {
  Youtube: Youtube,
  Tv: Tv,
  Award: Award,
  Leaf: Leaf
};

export const VedankurDifference = () => {
  return (
    <section id="about" className="py-24 bg-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-0 right-0 w-1/3 h-full opacity-5">
        <img
          src="https://images.unsplash.com/photo-1738907692230-ed72b94e83f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwxfHxheXVydmVkaWMlMjBoZXJic3xlbnwwfHx8fDE3NzUyODczOTN8MA&ixlib=rb-4.1.0&q=85"
          alt="botanical decoration"
          className="w-full h-full object-cover"
        />
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-forest-green mb-4">
            {vedankurDifference.title}
          </h2>
          <p className="text-xl text-sage-green font-semibold mb-6">
            {vedankurDifference.subtitle}
          </p>
          <p className="text-lg text-earth max-w-3xl mx-auto leading-relaxed">
            {vedankurDifference.description}
          </p>
        </div>

        {/* Highlights Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mt-16">
          {vedankurDifference.highlights.map((highlight, index) => {
            const IconComponent = iconMap[highlight.icon];
            return (
              <Card
                key={index}
                className="group relative overflow-hidden border-none bg-gradient-to-br from-cream to-white hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2"
              >
                <CardContent className="p-8 text-center">
                  {/* Icon Circle */}
                  <div className="mx-auto w-16 h-16 bg-sage-green rounded-full flex items-center justify-center mb-6 transform group-hover:scale-110 group-hover:rotate-6 transition-all duration-300">
                    <IconComponent className="w-8 h-8 text-white" />
                  </div>

                  <h3 className="text-xl font-serif font-bold text-forest-green mb-3">
                    {highlight.title}
                  </h3>
                  <p className="text-earth leading-relaxed">
                    {highlight.description}
                  </p>
                </CardContent>

                {/* Decorative Corner */}
                <div className="absolute top-0 right-0 w-20 h-20 bg-sage-green/10 rounded-bl-full transform scale-0 group-hover:scale-100 transition-transform duration-500"></div>
              </Card>
            );
          })}
        </div>

        {/* Doctors Section */}
        <div className="mt-20 bg-gradient-to-r from-sage-green/10 to-forest-green/10 rounded-3xl p-12">
          <h3 className="text-3xl font-serif font-bold text-forest-green text-center mb-12">
            Meet Your Healers
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
            <div className="text-center">
              <div className="w-32 h-32 mx-auto mb-6 rounded-full overflow-hidden border-4 border-sage-green">
                <img
                  src="https://images.unsplash.com/photo-1667904498869-933d459ddb1f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHw0fHxheXVydmVkaWMlMjBoZXJic3xlbnwwfHx8fDE3NzUyODczOTN8MA&ixlib=rb-4.1.0&q=85"
                  alt="Dr. Kirti"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="text-2xl font-serif font-bold text-forest-green mb-2">
                Dr. Kirti Khamkar-Diwate
              </h4>
              <p className="text-sage-green font-semibold mb-2">
                Specialist in PCOD, Infertility & Handmade Ayurvedic Products
              </p>
              <p className="text-earth">
                Expert in Women's Health & Wellness
              </p>
            </div>
            <div className="text-center">
              <div className="w-32 h-32 mx-auto mb-6 rounded-full overflow-hidden border-4 border-sage-green">
                <img
                  src="https://images.unsplash.com/photo-1730977806288-96b82f795008?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxheXVydmVkaWMlMjBoZXJic3xlbnwwfHx8fDE3NzUyODczOTN8MA&ixlib=rb-4.1.0&q=85"
                  alt="Dr. Sameer"
                  className="w-full h-full object-cover"
                />
              </div>
              <h4 className="text-2xl font-serif font-bold text-forest-green mb-2">
                Dr. Sameer Jondhale
              </h4>
              <p className="text-sage-green font-semibold mb-2">
                MD Ayurveda
              </p>
              <p className="text-earth">
                20+ Years of Clinical Excellence
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
